import { SpAlert } from '../../../../components/sp-alert/sp-alert.model';

export class Controller {

    /** @ngInject */
    constructor(AccountPasswordUpdate) {
        this.AccountPasswordUpdate = AccountPasswordUpdate;
    }

    $onInit() {
        this.application = this.resolve.application;
        this.password = this.resolve.application.password;
        this.username = null;
        this.resetEmail = null;
        this.passwordGenerationDate = null;
        this.isPasswordExpired = null;
    }

    save() {
        const {applicationId, companyUserAccountId} = this.application;
        this.AccountPasswordUpdate
            .save({applicationId, companyUserAccountId, username: this.username, password: this.password, resetEmail: this.resetEmail, passwordGenerationDate: this.passwordGenerationDate, isPasswordExpired: this.isPasswordExpired}).$promise
            .then(() => this.close({$value: this.password}))
            .catch((error) => {
                const message = ((error || {}).data || {}).message;
                const key = message || 'applications.account_password_updated_error';
                this.spAlert = new SpAlert('danger', key);
            });
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/user/applications/account-password-update/account-password-update.controller.js